export default "__VITE_ASSET__D90Sq670__"